import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Socials from 'components/bolt/socials/socials';
import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	renderShare() {
		const base = super.renderShare();
		const isDesktopWidth = this.props?.client?.isDesktopWidth;
		const socials = this.props?.appData?.header?.powsterHeader?.follow;

		if (isDesktopWidth && socials) {
			const socialsComp = (
				<Socials
					class={s.socials}
					socials={socials}
					navOpen
					fill={this.props?.appData?.styling?.variables?.headerNavSocialIcon || '#fff'}
					key="socials"
				/>
			);
			base.unshift(socialsComp);
		}
		return base;
	}

}
